import superadminGuard from '@/router/guards/superadmin-guard'
import multiGuard from '@/router/utils/vue-router-multiguard'
import authGuard from '@/router/guards/auth-guard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import ADMIN_PERMISSIONS from '@/constants/authorization/admin-permissions'

const superadminRoutes = [
  {
    path: '/super-admin',
    component: () => import(/* webpackChunkName: "super-admin" */ '@/views/superadmin/SuperAdminLayout.vue'),
    beforeEnter: multiGuard([checkTokenGuard, authGuard, superadminGuard]),
    children: [
      {
        path: '/',
        name: 'super:home',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/Dashboard.vue'),
      },
      {
        path: 'create-qr',
        name: 'super:create-qr',
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/marketing/qr/CreateQRPage.vue'),
      },
      {
        path: 'accounts',
        name: 'super:accounts',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS] },
        component: () => import(/* webpackChunkName: "superadmin-accounts" */ '@/views/superadmin/user-management/accounts/AccountsTable.vue'),
      },
      {
        path: 'accounts/edit/:id',
        name: 'super:accounts-edit',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.EDIT_ACCOUNT] },
        component: () => import(/* webpackChunkName: "superadmin-accounts" */ '@/views/superadmin/user-management/accounts/AccountForm.vue'),
      },
      {
        path: 'accounts/add',
        name: 'super:accounts-add',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ADD_ACCOUNT] },
        component: () => import(/* webpackChunkName: "superadmin-accounts" */ '@/views/superadmin/user-management/accounts/AccountForm.vue'),
      },
      {
        path: 'invoices',
        name: 'super:invoices',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.PAYMENT] },
        component: () => import(/* webpackChunkName: "superadmin-finance" */ '@/views/superadmin/finance/transactions/TransactionsTable.vue'),
      },
      {
        path: 'invoice/:id',
        name: 'super:invoice',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.PAYMENT] },
        component: () => import(/* webpackChunkName: "superadmin-finance" */ '@/views/superadmin/finance/transactions/Invoice.vue'),
      },
      {
        path: 'users',
        name: 'super:users',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.SUPER_ADMIN] },
        component: () => import(/* webpackChunkName: "superadmin-accounts" */ '@/views/superadmin/user-management/admins/Admins.vue'),
      },
      {
        path: 'landing-pages',
        name: 'super:landing-pages',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.SUPER_ADMIN] },
        component: () => import(/* webpackChunkName: "superadmin" */'@/views/superadmin/user-management/landing-pages/LandingPagesTable.vue'),
      },
      {
        path: 'customers',
        name: 'super:customers',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS] },
        component: () => import(/* webpackChunkName: "superadmin-accounts" */'@/views/superadmin/user-management/customers/ClientsTable.vue'),
      },
      // {
      //   path: 'link-tree',
      //   name: 'super:link-tree',
      //   meta: { adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS] },
      //   component: () => import(/* webpackChunkName: "superadmin" */'@/views/superadmin/user-management/link-tree/LinkTreeTable.vue'),
      // },
      {
        path: 'external-payment',
        name: 'super:external-payment',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.PAYMENT] },
        component: () => import(/* webpackChunkName: "superadmin-finance" */ '@/views/superadmin/finance/external-payment/RecieptsTable.vue'),
      },
      {
        path: 'quotations',
        name: 'super:quotations',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.PAYMENT] },
        component: () => import(/* webpackChunkName: "superadmin-finance" */ '@/views/superadmin/finance/quotations/QuotationsTable.vue'),
      },
      {
        path: 'quotation/:id',
        name: 'super:quotation',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.PAYMENT] },
        component: () => import(/* webpackChunkName: "superadmin-finance" */ '@/views/superadmin/finance/quotations/components/QuatationComponent.vue'),
      },
      {
        path: 'business-types',
        name: 'super:business-types',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.BUSINESS_TYPES] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/business-types/BusinessTypesTable.vue'),
      },
      {
        path: 'business-type/:slug?',
        name: 'super:business-type',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.BUSINESS_TYPES] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/business-types/components/TypeForm.vue'),
      },
      {
        path: 'plans',
        name: 'super:plans',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.PLANS] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/plans/PlansView.vue'),
      },
      {
        path: 'stickers',
        name: 'super:stickers',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.STICKERS] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/stickers/StickersTable.vue'),
      },
      {
        path: 'business-categories',
        name: 'super:business-categories',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.BUSINESS_CATEGORIES] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/business-categories/BusinessCategoriesTable.vue'),
      },
      {
        path: 'delivery-areas',
        name: 'super:delivery-areas',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.DELIVERY_AREAS] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/delivery-areas/DeliveryAreasTable.vue'),
      },
      {
        path: 'help',
        name: 'super:help',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.HELP] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/help/HelpSectionsTable.vue'),
      },
      {
        path: 'help/sections/:id',
        name: 'super:help-section',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.HELP] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/help/HelpQuestionsTable.vue'),
      },
      {
        path: 'requests',
        name: 'super:requests',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.CUSTOM_SOLUTIONS] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/requests/RequestsTable.vue'),
      },
      {
        path: 'vendor-requests',
        name: 'super:vendor-requests',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.PAYMENT] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/requests/VendorRequestsTable.vue'),
      },
      {
        path: 'vendor-request/:branchId?/:id',
        name: 'super:vendor-request',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.PAYMENT] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/requests/VendorRequest.vue'),
      },
      {
        path: 'announcements',
        name: 'super:announcements',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ANNOUNCEMENTS] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/announcements/AnnouncementsTable.vue'),
      },
      {
        path: 'announcements/form/:id?',
        name: 'super:announcement:form',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ANNOUNCEMENTS] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/dashboard/announcements/AnnouncementForm.vue'),
      },
      {
        path: 'statistics',
        name: 'super:statistics',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.STATISTICS] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/analysis/statistics/Statistics.vue'),
      },
      {
        path: 'reports',
        name: 'super:reports',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.RECEIVE_REGULAR_REPORT] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/analysis/report/Report.vue'),
      },
      {
        path: 'notifications',
        name: 'super:notifications',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.NOTIFICATIONS] },
        component: () => import(/* webpackChunkName: "superadmin-marketing" */ '@/views/superadmin/marketing/automated-notifications/AutomatedNotificationsTable.vue'),
      },
      {
        path: 'edit-notification/:id',
        name: 'super:edit-notification',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.NOTIFICATIONS] },
        component: () => import(/* webpackChunkName: "superadmin-marketing" */ '@/views/superadmin/marketing/automated-notifications/AutomatedNotificationForm.vue'),
      },
      {
        path: 'newsletter',
        name: 'super:newsletter',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.NOTIFICATIONS] },
        component: () => import(/* webpackChunkName: "superadmin-marketing" */ '@/views/superadmin/marketing/campaigns/CampaignsTable.vue'),
      },
      {
        path: 'edit-newsletter/:id?',
        alias: 'add-newsletter',
        name: 'super:newsletter-form',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.NOTIFICATIONS] },
        component: () => import(/* webpackChunkName: "superadmin-marketing" */ '@/views/superadmin/marketing/campaigns/CampaignForm.vue'),
      },
      {
        path: 'coupons',
        name: 'super:coupons',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.COUPONS] },
        component: () => import(/* webpackChunkName: "superadmin-marketing" */ '@/views/superadmin/marketing/coupons/OkCouponsRedeemsView.vue'),
      },
      {
        path: 'integrations',
        name: 'super:integrations',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.INTEGRATIONS] },
        component: () => import(/* webpackChunkName: "superadmin-integrations" */ '@/views/superadmin/settings/integrations/integrations/IntegrationsTable.vue'),
      },
      {
        path: 'integration-categories',
        name: 'super:integration-categories',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.INTEGRATIONS] },
        component: () => import(/* webpackChunkName: "superadmin-integrations" */ '@/views/superadmin/settings/integrations/integration-categories/IntegrationCategoriesTable.vue'),
      },
      {
        path: 'integration-connections',
        name: 'super:integration-connections',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.INTEGRATIONS] },
        component: () => import(/* webpackChunkName: "superadmin-integrations" */ '@/views/superadmin/settings/integrations/integration-connections/IntegrationConnectionsTable.vue'),
      },
      {
        path: 'mobile-accounts',
        name: 'super:mobile-accounts',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS] },
        component: () => import(/* webpackChunkName: "superadmin-mobile" */ '@/views/superadmin/mobile/test-accounts/AccountsTable.vue'),
      },
      {
        path: 'mobile-settings',
        name: 'super:mobile-settings',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS] },
        component: () => import(/* webpackChunkName: "superadmin-mobile" */ '@/views/superadmin/mobile/mobile-settings/AccountsTable.vue'),
      },
      {
        path: 'gifts-grace',
        name: 'super:gifts-grace',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.CHANGE_PACKAGE] },
        component: () => import(/* webpackChunkName: "superadmin" */ '@/views/superadmin/finance/gifts-gace/GiftsGraceTable.vue'),
      },
      {
        path: 'urls',
        name: 'super:urls',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.URL_REDIRECT] },
        component: () => import(/* webpackChunkName: "superadmin-urls" */ '@/views/superadmin/user-management/url-redirects/UrlsTable.vue'),
      },
      {
        path: 'register-requests',
        name: 'super:register-requests',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS] },
        component: () => import(/* webpackChunkName: "superadmin-accounts" */ '@/views/superadmin/user-management/accounts/RegisterRequestsTable.vue'),
      },
      {
        path: 'cloud-kitchen',
        name: 'super:cloud-kitchen',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS] },
        component: () => import(/* webpackChunkName: "superadmin-accounts" */ '@/views/superadmin/user-management/cloud-kitchen/CloudKitchenTable.vue'),
      },
      {
        path: 'addons',
        name: 'super:addons',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS] },
        component: () => import(/* webpackChunkName: "superadmin-addons" */ '@/views/superadmin/settings/addons/AddonsTable.vue'),
      },
      {
        path: 'marketing-channels',
        name: 'super:marketing-channels',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS] },
        component: () => import(/* webpackChunkName: "superadmin-marketing" */ '@/views/superadmin/marketing/marketing-channels/ChannelsTable.vue'),
      },
      {
        path: 'feature-statistics',
        name: 'super:feature-statistics',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS] },
        component: () => import(/* webpackChunkName: "superadmin-feature-statistics" */ '@/views/superadmin/dashboard/feature-statistics/FeaturesTable.vue'),
      },
      {
        path: 'feature-statistics/:feature',
        name: 'super:feature-statistics-show',
        meta: { adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS] },
        component: () => import(/* webpackChunkName: "superadmin-feature-statistics" */ '@/views/superadmin/dashboard/feature-statistics/FeatureUsersTable.vue'),
      },
    ],
  },
]

export default superadminRoutes
